import React from 'react'
import "./prod.css"
import { useNavigate } from 'react-router-dom';

function ShopProduct({data,id}: any) {

  const navigate = useNavigate();
  return (
    <div className='hd-prod-card' onClick={() => navigate("/product/" + id)}>
        <div className="hd-prod-thumbnail">
          <img src={data.img.data[0].attributes.url} alt="" />
        </div>
        <div className="hd-prod-details">
            <span className="name">{data.title}</span>
            <span className="price">&#8377;{data.price}</span>
            <div className='rating'>
            </div>
        </div>
    </div>
  )
}

export default ShopProduct
